import { createInertiaApp } from '@inertiajs/vue3';
import { initializeTheme } from '@/composables/useAppearance';
import AppLayout from '@/layouts/AppLayout.vue';
import SettingsLayout from '@/layouts/settings/Layout.vue';
import { initializeFlashToast } from '@/lib/flashToast';

const appName = import.meta.env.VITE_APP_NAME || 'CreativeTint';

void createInertiaApp({
    title: (title) => {
        if (! title) {
            return appName;
        }

        return title.includes(appName) ? title : `${title} · ${appName}`;
    },
    layout: (name) => {
        switch (true) {
            // Pages rendered without the AppLayout shell.
            case name === 'Welcome':
            case name.startsWith('auth/'):
            case name.startsWith('legal/'):
            case name.startsWith('onboarding/'):
            case name.startsWith('dev/'):
                return null;

            // Pages that also want the Settings sub-shell.
            case name.startsWith('settings/'):
            case name.startsWith('teams/'):
                return [AppLayout, SettingsLayout];

            // Everything else gets the standard app shell.
            default:
                return AppLayout;
        }
    },
    progress: {
        color: '#A78BFA',
        showSpinner: false,
    },
}).then(() => {
    // Run only after mount/hydrate so theme tweaks can't race SSR HTML.
    if (typeof window !== 'undefined') {
        initializeTheme();
        initializeFlashToast();
    }
});
